import { AZ_HEADER_OPTIONS, NON_STANDARD } from '../constants';
const reducer = (previousValue, currentValue) => previousValue + currentValue;
const buildAzAggregations = listAggregations => AZ_HEADER_OPTIONS.map(letter => {
  const match = listAggregations.find(({
    key
  }) => key === letter);
  if (letter === NON_STANDARD) {
    const nonStandardAgg = listAggregations.filter(({
      key
    }) => !AZ_HEADER_OPTIONS.find(option => option === key)).map(({
      doc_count: count
    }) => count);
    return {
      key: '0',
      doc_count: nonStandardAgg.length ? nonStandardAgg.reduce(reducer) : 0
    };
  }
  if (match) return match;
  return {
    key: letter,
    doc_count: 0
  };
});
export default buildAzAggregations;
//# sourceMappingURL=build-az-aggregations.js.map